import React, {useEffect, useState} from 'react';
import Routes from './routes';
import {useDispatch, useSelector} from "react-redux";
import {changeLayoutMode} from "./redux/actions";
import {setAuthorization} from './helpers/apiClient';
//Import Scss
import "./assets/scss/themes.scss";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

//fackbackend
//mport fakeBackend from './helpers/fake-backend';

// TODO
//fakeBackend();


function App() {
  const layoutMode = useSelector((state) => state.Layout.layoutMode);
  const dispatch = useDispatch();
  const [lastInteraction, setLastInteraction] = useState(Date.now());

  
  useEffect(() => {
    const mode = localStorage.getItem("layoutMode",layoutMode);
    const auth = JSON.parse(localStorage.getItem("authUser",layoutMode));

    if(mode){
      dispatch(changeLayoutMode(mode));
    }
    if(auth){
      setAuthorization(auth.token);
    }

    const handleUserInteraction = () => {
      setLastInteraction(Date.now());
    };

    window.addEventListener('mousemove', handleUserInteraction);
    window.addEventListener('keydown', handleUserInteraction);
    window.addEventListener('scroll', handleUserInteraction);
    window.addEventListener('click', handleUserInteraction);

  
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastInteraction >= 300000) {
        window.location.reload(); 
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [lastInteraction]);

  return <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Routes />
          </LocalizationProvider>;
};

export default App;
